import { render, staticRenderFns } from "./TenderArchiveDialog.vue?vue&type=template&id=247379d8"
import script from "./TenderArchiveDialog.vue?vue&type=script&lang=js"
export * from "./TenderArchiveDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports